import { useAuthentication } from '@/hooks/user/useAuthentication';

/**
 * Whether there is an authenticated session. Identity now comes from the Envoy
 * session (`/auth/userinfo`), so "has a token" means "userinfo resolved to a user".
 */
export const useHasAuthToken = () => {
  const { user } = useAuthentication();

  return Boolean(user);
};
